import { SmartConnectorStats } from './types';

export const defaultSmartConnectorStats: SmartConnectorStats = {
  used_count: 0,
};

export const FLOW_BAR_HEIGHT = 55;
export const FLOW_PADDING = 75;

export const NODE_TYPES = {
  add: 'add',
  junction: 'junction',
  upload: 'upload',
  runSmartConnector: 'run_smartconnector',
  additionalVariables: 'additionalVariables',
  connection_initialize_additional_variables:
    'connection_initialize_additional_variables',
  connection_run_get_requests: 'connection_run_get_requests',
  transformAdd: 'transformAdd',
} as const;
